// 'version' is imported by cypress.config.js and e2e/src/fixtures/test.fixture.ts.
// If you move this file, update both.
export const version = '1.3'
export const lastUpdated = 'October, 2025'
